/* demo.svelte generated by Svelte v3.3.0 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	select_option,
	select_value,
	set_style,
	space,
	text,
	to_number
} from "svelte/internal";
import eases from "eases";
import lerp from "./src/index";

function add_css() {
	var style = element("style");
	style.id = 'svelte-1dspap1-style';
	style.textContent = "html{font-family:Arial, Helvetica, sans-serif}body{padding:4vh 10vw;text-align:center}a.svelte-1dspap1{text-decoration:none}h1.svelte-1dspap1{font-size:50px;margin-bottom:50px;display:inline-block;background-color:#ffffff;padding:20px}h1.svelte-1dspap1 a.svelte-1dspap1{background-repeat:no-repeat;background-size:100% 4px;background-position:0 100%}.steps.svelte-1dspap1{position:absolute;z-index:-1;left:0;top:0;width:100.5vw;height:100%;display:flex}.steps.svelte-1dspap1 div.svelte-1dspap1{flex:1}.pickers.svelte-1dspap1{display:flex;justify-content:space-between}.controls.svelte-1dspap1{display:flex;flex-direction:column;align-items:center;padding:100px}.controls.svelte-1dspap1 input[type=\"range\"].svelte-1dspap1{margin-bottom:30px;width:50%}";
	append(document.head, style);
}

function get_each_context(ctx, list, i) {
	const child_ctx = Object.create(ctx);
	child_ctx.step = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = Object.create(ctx);
	child_ctx.easing = list[i];
	return child_ctx;
}

function get_each_context_2(ctx, list, i) {
	const child_ctx = Object.create(ctx);
	child_ctx.color = list[i];
	child_ctx.i = i;
	return child_ctx;
}

function get_each_context_3(ctx, list, i) {
	const child_ctx = Object.create(ctx);
	child_ctx.char = list[i];
	child_ctx.i = i;
	return child_ctx;
}

// (87:4) {#each linkChars as char, i}
function create_each_block_3(ctx) {
	var span, t_value = ctx.char, t;

	return {
		c() {
			span = element("span");
			t = text(t_value);
			set_style(span, "color", lerp(...ctx.colors, ctx.i / (ctx.linkChars.length - 1)));
		},

		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},

		p(changed, ctx) {
			if (changed.lerp || changed.colors || changed.linkChars) {
				set_style(span, "color", lerp(...ctx.colors, ctx.i / (ctx.linkChars.length - 1)));
			}
		},

		d(detaching) {
			if (detaching) {
				detach(span);
			}
		}
	};
}

// (97:2) {#each colors as color, i}
function create_each_block_2(ctx) {
	var input, input_value_value, dispose;

	return {
		c() {
			input = element("input");
			attr(input, "type", "color");
			input.className = "color-input";
			input.value = input_value_value = ctx.color;
			dispose = listen(input, "change", ctx.updateColor(ctx.i));
		},

		m(target, anchor) {
			insert(target, input, anchor);
		},

		p(changed, new_ctx) {
			ctx = new_ctx;
			if ((changed.colors) && input_value_value !== (input_value_value = ctx.color)) {
				input.value = input_value_value;
			}
		},

		d(detaching) {
			if (detaching) {
				detach(input);
			}

			dispose();
		}
	};
}

// (109:4) {#each Object.keys(eases) as easing}
function create_each_block_1(ctx) {
	var option, t_value = ctx.easing, t, option_value_value;

	return {
		c() {
			option = element("option");
			t = text(t_value);
			option.__value = option_value_value = ctx.easing;
			option.value = option.__value;
		},

		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t);
		},

		p(changed, ctx) {
			option.value = option.__value;
		},

		d(detaching) {
			if (detaching) {
				detach(option);
			}
		}
	};
}

// (115:2) {#each steps as step}
function create_each_block(ctx) {
	var div;

	return {
		c() {
			div = element("div");
			set_style(div, "background-color", ctx.step);
			div.className = "svelte-1dspap1";
		},

		m(target, anchor) {
			insert(target, div, anchor);
		},

		p(changed, ctx) {
			if (changed.steps) {
				set_style(div, "background-color", ctx.step);
			}
		},

		d(detaching) {
			if (detaching) {
				detach(div);
			}
		}
	};
}

function create_fragment(ctx) {
	var h1, a, t0, t1, div0, t2, div1, input, t3, select, t4, div2, dispose;

	var each_value_3 = ctx.linkChars;

	var each_blocks_3 = [];

	for (var i = 0; i < each_value_3.length; i += 1) {
		each_blocks_3[i] = create_each_block_3(get_each_context_3(ctx, each_value_3, i));
	}

	var each_value_2 = ctx.colors;

	var each_blocks_2 = [];

	for (var i = 0; i < each_value_2.length; i += 1) {
		each_blocks_2[i] = create_each_block_2(get_each_context_2(ctx, each_value_2, i));
	}

	var each_value_1 = Object.keys(eases);

	var each_blocks_1 = [];

	for (var i = 0; i < each_value_1.length; i += 1) {
		each_blocks_1[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	var each_value = ctx.steps;

	var each_blocks = [];

	for (var i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			h1 = element("h1");
			a = element("a");

			for (var i = 0; i < each_blocks_3.length; i += 1) {
				each_blocks_3[i].c();
			}

			t0 = text("\n  demo");
			t1 = space();
			div0 = element("div");

			for (var i = 0; i < each_blocks_2.length; i += 1) {
				each_blocks_2[i].c();
			}

			t2 = space();
			div1 = element("div");
			input = element("input");
			t3 = space();
			select = element("select");

			for (var i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			t4 = space();
			div2 = element("div");

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}
			a.href = "https://github.com/sunify/lerp-color";
			set_style(a, "background-image", "linear-gradient(to right, " + ctx.colors.join(', ') + ")");
			a.className = "svelte-1dspap1";
			h1.className = "svelte-1dspap1";
			div0.className = "pickers svelte-1dspap1";
			attr(input, "type", "range");
			input.min = "3";
			input.max = "300";
			input.className = "svelte-1dspap1";
			if (ctx.easing === void 0) add_render_callback(() => ctx.select_change_handler.call(select));
			div1.className = "controls svelte-1dspap1";
			div2.className = "steps svelte-1dspap1";
			div2.id = "steps";

			dispose = [
				listen(input, "change", ctx.input_change_input_handler),
				listen(input, "input", ctx.input_change_input_handler),
				listen(select, "change", ctx.select_change_handler)
			];
		},

		m(target, anchor) {
			insert(target, h1, anchor);
			append(h1, a);

			for (var i = 0; i < each_blocks_3.length; i += 1) {
				each_blocks_3[i].m(a, null);
			}

			append(h1, t0);
			insert(target, t1, anchor);
			insert(target, div0, anchor);

			for (var i = 0; i < each_blocks_2.length; i += 1) {
				each_blocks_2[i].m(div0, null);
			}

			insert(target, t2, anchor);
			insert(target, div1, anchor);
			append(div1, input);

			input.value = ctx.stepsCount;

			append(div1, t3);
			append(div1, select);

			for (var i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(select, null);
			}

			select_option(select, ctx.easing)

			insert(target, t4, anchor);
			insert(target, div2, anchor);

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div2, null);
			}
		},

		p(changed, ctx) {
			if (changed.lerp || changed.colors || changed.linkChars) {
				each_value_3 = ctx.linkChars;

				for (var i = 0; i < each_value_3.length; i += 1) {
					const child_ctx = get_each_context_3(ctx, each_value_3, i);

					if (each_blocks_3[i]) {
						each_blocks_3[i].p(changed, child_ctx);
					} else {
						each_blocks_3[i] = create_each_block_3(child_ctx);
						each_blocks_3[i].c();
						each_blocks_3[i].m(a, null);
					}
				}

				for (; i < each_blocks_3.length; i += 1) {
					each_blocks_3[i].d(1);
				}
				each_blocks_3.length = each_value_3.length;
			}

			if (changed.colors) {
				set_style(a, "background-image", "linear-gradient(to right, " + ctx.colors.join(', ') + ")");
			}

			if (changed.colors || changed.updateColor) {
				each_value_2 = ctx.colors;

				for (var i = 0; i < each_value_2.length; i += 1) {
					const child_ctx = get_each_context_2(ctx, each_value_2, i);

					if (each_blocks_2[i]) {
						each_blocks_2[i].p(changed, child_ctx);
					} else {
						each_blocks_2[i] = create_each_block_2(child_ctx);
						each_blocks_2[i].c();
						each_blocks_2[i].m(div0, null);
					}
				}

				for (; i < each_blocks_2.length; i += 1) {
					each_blocks_2[i].d(1);
				}
				each_blocks_2.length = each_value_2.length;
			}

			if (changed.stepsCount) input.value = ctx.stepsCount;

			if (changed.eases) {
				each_value_1 = Object.keys(eases);

				for (var i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks_1[i]) {
						each_blocks_1[i].p(changed, child_ctx);
					} else {
						each_blocks_1[i] = create_each_block_1(child_ctx);
						each_blocks_1[i].c();
						each_blocks_1[i].m(select, null);
					}
				}

				for (; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].d(1);
				}
				each_blocks_1.length = each_value_1.length;
			}

			if (changed.easing) select_option(select, ctx.easing)

			if (changed.steps) {
				each_value = ctx.steps;

				for (var i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(changed, child_ctx);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div2, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}
				each_blocks.length = each_value.length;
			}
		},

		i: noop,
		o: noop,

		d(detaching) {
			if (detaching) {
				detach(h1);
			}

			destroy_each(each_blocks_3, detaching);

			if (detaching) {
				detach(t1);
				detach(div0);
			}

			destroy_each(each_blocks_2, detaching);

			if (detaching) {
				detach(t2);
				detach(div1);
			}

			destroy_each(each_blocks_1, detaching);

			if (detaching) {
				detach(t4);
				detach(div2);
			}

			destroy_each(each_blocks, detaching);

			run_all(dispose);
		}
	};
}

const linkText = "@sunify/lerp-color";

function instance($$self, $$props, $$invalidate) {
	

  // props
  let stepsCount = 30;

  let colors = ["#41bbe9", "#b710da", "#fd8978"];
  const updateColor = i => e => {
    colors[i] = e.target.value; $$invalidate('colors', colors);
  };

  let easing = "linear";
  const linkChars = linkText.split("");

	function input_change_input_handler() {
		stepsCount = to_number(this.value);
		$$invalidate('stepsCount', stepsCount);
	}

	function select_change_handler() {
		easing = select_value(this);
		$$invalidate('easing', easing);
		$$invalidate('eases', eases);
	}

	let getColor, steps;

	$$self.$$.update = ($$dirty = { colors: 1, easing: 1, stepsCount: 1, getColor: 1 }) => {
		if ($$dirty.colors || $$dirty.easing) { $$invalidate('getColor', getColor = n =>
        lerp(...colors, Math.max(0, Math.min(1, eases[easing](n))))); }
		if ($$dirty.stepsCount || $$dirty.getColor) { $$invalidate('steps', steps = Array.from({ length: stepsCount }, (_, i) =>
        getColor(i / (stepsCount - 1))
      )); }
	};

	return {
		stepsCount,
		colors,
		updateColor,
		easing,
		linkChars,
		steps,
		input_change_input_handler,
		select_change_handler
	};
}

class Demo extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1dspap1-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, []);
	}
}

export default Demo;